module.exports = __webpack_public_path__ + "img/4-cartoon.2e51da4c.jpg";